module.exports = __webpack_public_path__ + "img/Vector15.744eac4f.svg";